module.exports = __webpack_public_path__ + "static/Group 117-146beb5177ea027ff1746dd48121e17d.png";